var _defs, _rect, _g, _g2, _g3, _g4, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 400,
    viewBox: "0 0 600 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pyBg",
    x1: 0,
    y1: 0,
    x2: 600,
    y2: 400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512BD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD0031"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#pyBg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 50,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 70,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 330,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 300,
    r: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 230,
    height: 200,
    rx: 18,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 230,
    height: 46,
    rx: 18,
    fill: "#512BD4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28,
    width: 230,
    height: 18,
    fill: "#512BD4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 12,
    r: 6,
    fill: "#ffffff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 12,
    r: 6,
    fill: "#ffffff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 70,
    width: 120,
    height: 12,
    rx: 6,
    fill: "#d7d2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 98,
    width: 182,
    height: 10,
    rx: 5,
    fill: "#eceaf7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 122,
    width: 182,
    height: 10,
    rx: 5,
    fill: "#eceaf7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 146,
    width: 120,
    height: 10,
    rx: 5,
    fill: "#eceaf7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 140,
    width: 56,
    height: 30,
    rx: 8,
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 161,
    fontFamily: "Poppins, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#ffffff",
    textAnchor: "middle"
  }, "$"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,90)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 20 l7 0 l4 14 a44 44 0 0 1 12 7 l14 -4 l4 6 l-9 12 a44 44 0 0 1 0 14 l9 12 l-4 6 l-14 -4 a44 44 0 0 1 -12 7 l-4 14 l-7 0 l-4 -14 a44 44 0 0 1 -12 -7 l-14 4 l-4 -6 l9 -12 a44 44 0 0 1 0 -14 l-9 -12 l4 -6 l14 4 a44 44 0 0 1 12 -7 Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 83,
    r: 20,
    fill: "#DD0031"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 83,
    r: 9,
    fill: "#ffffff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(430,250)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 60,
    rx: 42,
    ry: 14,
    fill: "#ffd54f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 46,
    rx: 42,
    ry: 14,
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 32,
    rx: 42,
    ry: 14,
    fill: "#ffd54f"
  }), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 38,
    fontFamily: "Poppins, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#8a6d00",
    textAnchor: "middle"
  }, "$"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 372,
    fontFamily: "Poppins, Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700,
    fill: "#ffffff"
  }, "Payroll Management System")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.6039a49990ca9f5ea57418152769db5d.svg";
export { ForwardRef as ReactComponent };